/**
 * Склейка className без внешней зависимости (clsx/classnames в ui-kit не тянем).
 *
 * Возвращает undefined, а не пустую строку: React в этом случае вообще не пишет
 * атрибут class, и в разметке не остаётся мусорного `class=""`.
 */
export function cx(
  ...values: ReadonlyArray<string | false | null | undefined>
): string | undefined {
  const names = values.filter(
    (value): value is string => typeof value === 'string' && value !== '',
  );
  return names.length > 0 ? names.join(' ') : undefined;
}
